// <s-product-gallery> keeps the main media track and its thumbnail strip in sync.
// Thumbnails are buttons using commandfor + command="--show" with data-index.
class SProductGallery extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    const track = this.querySelector('[data-gallery-track]');
    if (!track) return;

    this.addEventListener('command', this.#handleCommand, { signal: this.#ac.signal });

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const index = Number(entry.target.getAttribute('data-gallery-slide'));
          this.#setActive(index);
        }
      },
      { root: track, threshold: 0.6 }
    );
    for (const slide of track.querySelectorAll('[data-gallery-slide]')) {
      this.#observer.observe(slide);
    }
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #handleCommand = (event) => {
    if (event.command !== '--show') return;
    const index = Number(event.source?.dataset.index || 0);
    const slide = this.querySelector(`[data-gallery-slide="${index}"]`);
    if (!slide) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    this.#setActive(index);
  };

  #setActive(index) {
    for (const thumb of this.querySelectorAll('[data-gallery-thumb]')) {
      const isActive = Number(thumb.dataset.index) === index;
      thumb.toggleAttribute('data-active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    }
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
